// @module NetSuite.SuiteCommCPQ.Main
define('NetSuite.SuiteCommCPQ.Main.Debug', [
    'NetSuite.SuiteCommCPQ.Main.Configuration'
], function (Configuration) {
    //
    'use strict';
    var logsEnabled,
        debugMode = Configuration.isDebugMode();
    if (debugMode) {
        logsEnabled = true;
    }
    var Main_Debug = {
        enable: function() {
            logsEnabled = true;
        },
        log: function(text, message, force) {
            if (Configuration.isBrowser() && (logsEnabled || force)) {
                if (!message) {
                    console.log(text);
                } else {
                    console.log(text, message);
                }
            }
        },
        error: function(text, message) {
            if (Configuration.isBrowser()) {
                if (!message) {
                    console.error(text);
                } else {
                    console.error(text, message);
                }
            }
        },
        setGlobal: function (name, object) {
            if (Configuration.isBrowser() && debugMode && name && object) {
                window.vcpq = window.vcpq || {};
                window.vcpq[name] = object;
            }
        },
        _init: function() {
            this.setGlobal('main_debug', this);
        }
    };
    return Main_Debug;
});
